// @ts-strict-ignore
import { USER_ENDPOINT } from './constants';
import { UpdateDevicesRequest, EnableDisableDevicesRequest } from './actions/devices';
import {
    RunwayResponse,
    User,
    Release,
    AppSettings,
    SSORedirectResponse,
    SSOAdminPortalResponse,
    DashboardState,
    AuthCredentials,
    AppHome,
    NewVersionValidationResult,
    OrganizationEntity,
    CandidateSelectableCommits,
    ReleaseStatisticsHistory,
    RolloutMonitoring,
    BumpVersionFile,
    OrgOverviewV2,
    ScanResult,
    OpenPRQuickstartResult,
    QuickStartCIFilesResult,
    GetProvisioningProfilesResult,
    FeatureFlag,
    BuildDetails,
    FetchBuildDistributionBucketsWithRecentBuildsResponse,
    FetchBuildDistributionBucketResponse,
    FetchBuildDistributionBucketBuildsResponse,
    CreateBuildDistributionBucketResponse,
    CommsMention,
    BuildDistroBucketBase,
    UpdateBuildDistributionBuildTesterNotesResponse,
    ArchiveBuildDistributionBucketResponse,
    UpdateBuildDistroBucketNotificationSettingsResponse,
    ToggleBuildDistroBucketNotificationsResponse,
    UpdateBuildDistributionBucketResponse,
    ShareBuildDistributionBuildWithTestersResponse,
    FetchBuildDistributionSharedWithMeBuildsResponse,
    FetchBuildDistributionBucketBuildResponse,
    UpdateBuildDistroBucketAutomationsSettingsResponse,
    FetchBuildDistributionBucketBuildsWorkItemsTimelineResponse,
    RepoContributors,
    LocalizedMetadata,
    GetAllDevicesResponse,
    TranslationDirectory,
    GeneratedReleaseNotesResponse,
    ReleaseStep,
    RunwayModelsResponse,
    BuildDistroBuild,
    RunwayResponseV2,
    RunwayResponseType,
    GeneratedReleaseNotesType,
    GeneratedReleaseNotesMarkdownContext,
    FetchExternalBuildDistroBucketRequest,
    FetchExternalBuildDistroBucketResponse,
    FetchExternalBuildDistroBuildRequest,
    FetchExternalBuildDistroBuildResponse,
    FetchExternalBuildDistroBucketBuildsRequest,
    FetchExternalBuildDistroBucketBuildsResponse,
    AllReleaseCalendarData,
    GeneratedReleaseNotesStepContext,
    ReleaseTag,
    ArchiveBuildDistributionBuildResponse,
    ChecklistItemTemplate,
    ChecklistAttachment,
} from './types';
import { SummaryViewResponseAPI, OrgDestinationsResponse } from './types/summaryView';
import {
    UpdateRegressionStatusRequestReleaseStep,
    UpdateScreenshotsApprovalRequestReleaseStep,
    UpdateMetadataApprovalRequestReleaseStep,
    ReleaseStepEndBetaSoakRequest,
    NewReleaseRequest,
    TagReleaseRequestReleaseStep,
    UpdateReleaseNotesRequestReleaseStep,
    UpdateReleaseRequest,
    UpdateReleasePlanningSummaryRequest,
    UpdateSelectedBuildRequest,
    UpdateAppleAppStoreSettingsRequestForReleaseStep,
    BaseUpdateReleaseRequest,
    UpdateGooglePhasedReleaseRequestReleaseStep,
    UpdateApplePhasedReleaseRequestReleaseStep,
    StartWorkflowRequest,
    SelectRCBuildRequest,
    CreateOrUpdateBetaBuildLocalizationsRequest,
    AddIndividualTesterToBuildRequestReleaseStep,
    AddBetaGroupsToBuildRequest,
    SubmitBetaBuildForReviewRequestReleaseStep,
    PromoteToTestingTrackRequestReleaseStep,
    UpdateChecklistItemStatusRequest,
    UpdateReleaseStepChecklistItemCommentRequest,
    DeleteScreenshotRequestReleaseStep,
    RetryAppStoreArtifactUploadRequest,
    RetryDsymUploadRequest,
    GetBuildDetailsRequest,
    StartResignSequenceRequest,
    UpdateCustomizedReleaseSummaryMessageRequest,
    UpdateGoogleAppStoreReleaseSettingsRequestForReleaseStep,
    UpdateReviewDetailsRequestForReleaseSteps as UpdateReviewDetailsRequestForReleaseStep,
    UpdateTranslationsApprovalRequest,
    DeleteAppPreviewRequest,
    UpdateReviewSubmissionItemRequest,
    UpdateHuaweiPhasedReleaseRequestReleaseStep,
    UpdateHuaweiAppStoreReleaseSettingsRequestForReleaseStep,
    UpdateAdditionalSelectedBuildsRequest,
    SubmitAppForReviewRequestReleaseStep,
    ReleaseAppleVersionRequestReleaseStep,
} from './actions/release';
import {
    NewFeatureAffiliationRequest,
    DeleteFeatureAffiliationRequest,
    UpdateFeatureAffiliationPatternRequest,
    UpdateReleaseBranchPatternRequest,
    DeleteReleaseBranchPatternRequest,
    NewReleaseBranchPatternRequest,
    NewReleaseTagPatternRequest,
    UpdateReleaseTagPatternRequest,
    DeleteReleaseTagPatternRequest,
    UpdateBetaStyleRequest,
    ReleaseStepNewChecklistItemRequest,
    ReleaseStepUpdateChecklistItemRequest,
    ReleaseStepDeleteChecklistItemRequest,
    BaseAppRequest,
    SetAdditionalBranchesRequest,
    UpdateAppleAppStoreReleaseDefaults,
    UpdatePlayAppStoreReleaseDefaults,
    UpdateDefaultReleaseNotes,
    UpdateAutomationSettingsRequest,
    ReleaseScheduleCadenceSettingsRequest,
    UpdateChecklistItemsOrderRequest,
    AddReleasePilotsRequest,
    RemoveReleasePilotRequest,
    UpdateVersioningDefaultsRequest,
    UpdateNotificationSettingsRequest,
    UpdateStepNotificationConfigRequest,
    DeleteStepNotificationConfigRequest,
    UpdateBumpVersionOverrideFilesRequest,
    UpdateNonBlockingStepsRequest,
    GetCandidateSelectableCommitsRequest,
    TagCommitRequest,
    UploadDefaultReviewAttachmentRequest,
    RemoveDefaultReviewAttachmentRequest,
    UpdateFilterPathsRequest,
    UpdateUserRolesMapRequest,
    UpdateAppUsersRequest,
    UpdateMonitoringMetricRequest,
    AddMonitoringMetricRequest,
    DeleteMonitoringMetricRequest,
    TriggerIntegrationRefreshRequest,
    UpdateCustomMessagesTemplatesRequest,
    UpdateReleasePilotsOrderRequest,
    GenerateQuickStartCIFilesRequest,
    OpenPRForQuickStartCIFilesRequest,
    GetAppRepoContributorsRequest,
    DeleteSigningKeyRequest,
    UpdateSigningKeyRequest,
    AddDeviceRequest,
    AddUserDeviceRequest,
    UpdateTranslationDirectoriesRequest,
    UpdateQualitativeOnboardingStatusRequest,
    UpdateFixesFeatureSettingsRequest,
    UpdateBundleSizeDeviceModelRequest,
    UpdateHuaweiAppStoreReleaseDefaults,
    UpdateUserEmailNotificationSettingsRequest,
    UpdateShowSimplifiedBdUISettingsRequest,
    GetReleaseCalendarRequest,
} from './actions/appSettings';
import {
    CreateDeleteIntegrationResponse,
    CreateIntegrationRequest,
    IntegrationRequest,
    RefreshIntegrationRequest,
    UpdateIntegrationAliasRequest,
    UpdateIntegrationRequest,
} from './actions/integrations';
import {
    AddAppsRequest,
    AppSearchRequest,
    AppSearchResponse,
    AppStateResponse,
    CreateAppRequest,
    DeleteAppRequest,
    GenerateBinaryInstallLinkRequest,
    GetPossibleBaseTagsRequest,
    GetPossibleSourceVersionsForRollbackRequest,
    PredictReleaseVersionRequest,
    SendBinaryInstallLinkToCommsRequest,
    SendInstallLinkToMyselfRequest,
    SendNotificationTestDMRequest,
    ValidateReleaseVersionRequest,
} from './actions/app';
import qs from 'query-string';
import { NewPasswordRequest, SignUpRequest, VerifyCommsUserRequest } from './actions/user';
import { LoginWithSSORequest, UserLoginRequest, Verify2FACodeRequest } from './actions/login';
import { merge } from 'lodash';
import * as AnalyticEvents from './utils/analytics';
import {
    AppEntityRequest,
    ReleaseEntityRequest,
    OrgOverviewEntityRequest,
    ReleasesRequest,
    BuildDistributionBucketsWithRecentBuildsEntityRequest,
    BuildDistributionBucketEntityRequest,
    BuildDistributionBucketBuildsEntityRequest,
    CreateBuildDistributionBucketRequest,
    AddBuildDistroBucketMembersRequest,
    ToggleBuildDistroBucketNotificationsRequest,
    UpdateBuildDistroBucketNotificationSettingsRequest,
    RemoveBuildDistroBucketMemberRequest,
    UpdateBuildDistroBucketMemberPermissionsRequest,
    UpdateBuildDistributionBuildTesterNotesRequest,
    ArchiveBuildDistributionBucketRequest,
    UpdateBuildDistributionBucketRequest,
    ShareBuildDistributionBuildWithTestersRequest,
    BuildDistributionSharedWithMeBuildsEntityRequest,
    BuildDistributionBucketBuildEntityRequest,
    BuildDistributionSearchBuildsEntityRequest,
    UpdateBuildDistroBucketAutomationSettingsRequest,
    BuildDistributionBucketBuildsWorkItemsTimelineRequest,
    GetAllDevicesRequest,
    ReleaseStepEntityRequest,
    StepRunEntityRequest,
    StepConfigEntityRequest,
    StepRunChecklistItemEntityRequest,
    ChecklistItemTemplateEntityRequest,
    AutomationEntityRequest,
    WorkflowOverviewEntityRequest,
    ArchiveBuildDistributionBuildRequest,
    PingAllPendingWorkOwnersRequest,
    BuildDistributionBucketDownloadMetricRequest,
    OrgSummaryViewEntityRequest,
    OrgEntityRequest,
    StepRunsSummaryEntityRequest,
    WorkflowRunEntityRequest,
    OrgOverviewFilters,
} from './actions/entities';
import {
    AppSettingsV2APIResponse,
    CreateAppApiResponse,
    AuthResponse,
    UserOrgsResponse,
    ConfigResponse,
    CreateAppAddIntegrationResponse,
    ChecklistItemUpdatableAPIResponse,
} from './apiResponseTypes';
import {
    appEndpoint,
    appStateEndpoint,
    automationEndpoint,
    checklistItemTemplateEndpoint,
    orgEndpoint,
    releaseEndpoint,
    stepConfigEndpoint,
    stepRunChecklistItemEndpoint,
    stepRunEndpoint,
    workflowEndpoint,
    workflowRunEndpoint,
} from './helpers/apiHelpers';
import { FetchStateRequest } from './actions/auth';
import { ForgotPasswordRequest } from './components/login-signup/ForgotPasswordModal';
import { RunwayEndpoint } from './endpoints';
import {
    UpdateMergeAccountsSettingRequest,
    UpdateUserRequest,
    RemoveOrgUserRequest,
    AddNewWebhookRequest,
    DeleteWebhookRequest,
    UpdateWebhookRequest,
    DeleteApiKeyRequest,
    UpdateAddNewUsersToAppsSettingRequest,
    UpdateUserGroupsForDirectorySyncGroupRequest,
    BaseUpdateOrgSettingsRequest,
    UpdateOrgUserVCSUserNameRequest,
    CreateCustomGroupRequest,
    UpdateCustomGroupRequest,
    DeleteCustomGroupRequest,
    UpdateProviderIdToUserGroupsToCommsGroupsMapRequest,
    UpdateOrgUserTimezonePreferenceRequest,
    UpdateOrgTimezoneRequest,
    UpdateAISettingsRequest,
} from './actions/orgSettings';
import { InviteTeamRequest } from './actions/organization';
import formurlencoded from 'form-urlencoded';
import { AddApiKeyRequest, CreatePublicApiKeyResponse } from './actions/publicApi';
import { PingAllChecklistItemOwnersRequest } from './components/StepChecklistContainer';
import { PingChecklistItemOwnersRequest } from './components/PingButton';
import { ToggleFeatureFlagRequest } from './actions/featureFlags';
import { TriggerBuildDistributionBuildRequest } from './actions/buildDistribution';
import {
    AddFixRequest,
    ApproveFixRequest,
    BaseUpdateFeatureWorkItemRequest,
    BaseUpdateReleaseStepRequest,
    ExportTranslationsRequest,
    IgnoreUnignoreFRItemRequest,
    MoveFixRequestToPendingApproval,
    RejectFixRequest,
    SyncTranslationsRequest,
    UpdateFixRequest,
    UploadTranslationsRequest,
} from '@/actions/releaseStep';
import { Nullable } from '@/typescriptHelpers';
import { StepRun } from '@/types/stepRun';
import {
    CreateChecklistItemTemplateRequest,
    DeleteChecklistItemTemplateRequest,
    UpdateBetaTestingStyleRequest,
    UpdateChecklistItemTemplateOrderRequest,
    UpdateChecklistItemTemplateRequest,
    UpdateRegressionTestingStrategyRequest,
    UpdateStepConfigRequest,
} from '@/actions/stepConfig';
import {
    AssignBetaGroupsToBuildRequest,
    CreateChecklistItemRequest,
    EndBetaSoakRequest,
    SubmitBetaBuildToReviewRequest,
    UpdateChecklistItemCommentRequest,
    UpdateChecklistItemRequest,
    CreateOrUpdateBuildLocalizationsRequest,
    UpdateReviewDetailsRequest,
    SubmitAppForReviewRequest,
    UpdateSelectedBuildsInAppStoreRequest,
    UpdatePhasedReleaseRequest,
    TagReleaseRequest,
    UpdateAdditionalSelectedBuildsInAppStoreRequest,
    UpdateAppStoreSettingsRequest,
    UpdateMetadataRequest,
    ApproveMetadataRequest,
    ReleaseAppleVersionRequest,
    DeleteScreenshotRequest,
    UpdateScreenshotsApprovalRequest,
    UpdateApprovalOverrideRequest,
    AddReviewSubmissionItemRequest,
    RemoveReviewSubmissionItemRequest,
    TriggerBuildSystemWorkflowRequest,
    RetryArtifactUploadRequest,
    UpdateRegressionStatusRequest,
    UpdateOrgChecklistItemTemplateRequest,
    DeleteOrgChecklistItemTemplateRequest,
    LockBuildRequest,
    OverrideCIFailureRequest,
    CreateOrgChecklistItemTemplateRequest,
} from '@/actions/stepRun';
import { StepConfig } from '@/types/stepConfig';
import { WorkflowOverview } from './types/workflowOverview';
import {
    TriggerBatchActionRequest,
    PingPendingChecklistItemsForStepGroupRequest,
    BulkMarkCLIsAsCompletedRequest,
    UpdateDestinationStatusesRequest,
} from './actions/workflowRun';
import { UpdateDestinationDetailsRequest } from './types/destinations';

enum ApiRequestType {
    get = 'GET',
    post = 'POST',
    put = 'PUT',
    delete = 'DELETE',
    patch = 'PATCH',
}

const formEncodedBaseHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
};

const jsonBaseHeaders = {
    'Content-Type': 'application/json',
    'Accept-Encoding': 'gzip, deflate, br',
};

export interface BaseAuthedApiRequest {
    orgId: string;
}

export type UpdatableEndpointResponse = Promise<RunwayResponseV2<RunwayModelsResponse>>;

/*****************************
 Login/User Endpoints
 *****************************/

export function getAppConfig(): Promise<ConfigResponse> {
    const url = 'api/config';

    return runwayFetchWithoutAuth(url, ApiRequestType.get);
}

export function login(request: UserLoginRequest): Promise<AuthResponse> {
    const body = formurlencoded(request);
    const url = `${USER_ENDPOINT}/login`;

    return runwayFetchWithoutAuth(url, ApiRequestType.post, formEncodedBaseHeaders, body);
}

export function loginWithSSO(request: LoginWithSSORequest): Promise<SSORedirectResponse> {
    const state = {
        redirect_path: request.redirectPath,
        hubspot_user_token: request.hubSpotUserToken,
    };

    if (request.stapeId) {
        state['stape_id'] = request.stapeId;
    }

    const queryParams = {
        state: JSON.stringify(state),
        email: request.email,
    };
    const encodedParams = qs.stringify(queryParams);

    const url = `api/sso/auth?${encodedParams}`;

    return runwayFetchWithoutAuth(url, ApiRequestType.get, null);
}

export function verify2FACode(request: Verify2FACodeRequest): Promise<AuthResponse> {
    const url = `${USER_ENDPOINT}/login/2fa`;

    return runwayFetchWithoutAuth(url, ApiRequestType.post, jsonBaseHeaders, JSON.stringify(request));
}

export function refreshToken(request?: { accessToken?: string }): Promise<AuthResponse> {
    const url = `${USER_ENDPOINT}/token/refresh`;
    const body =
        request ?
            {
                ...request,
            }
        :   null;

    return runwayFetchWithoutAuth(url, ApiRequestType.post, jsonBaseHeaders, JSON.stringify(body));
}

export function fetchState(request: FetchStateRequest, auth: AuthCredentials): Promise<DashboardState> {
    let url = `${USER_ENDPOINT}/state`;

    if (request.orgId) {
        const queryParams = qs.stringify({
            orgId: request.orgId,
            stapeId: request.stapeId,
            hsUserToken: request.hubspotUserToken,
        });
        url = `${USER_ENDPOINT}/state?${queryParams}`;
    }

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function resendVerificationEmail(auth: AuthCredentials): Promise<unknown> {
    const url = `${USER_ENDPOINT}/resendVerifyEmail`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function newPassword(request: NewPasswordRequest, auth: AuthCredentials): Promise<User> {
    const url = `${USER_ENDPOINT}/${request.userId}/resetPassword`;
    const body = {
        password: request.newPassword,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateShouldShowSimplifiedBdUI(
    request: UpdateShowSimplifiedBdUISettingsRequest,
    auth: AuthCredentials,
): Promise<User> {
    const url = `${USER_ENDPOINT}/${request.userId}`;
    const body = {
        shouldShowSimplifiedBuildDistributionUI: request.enabled,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function generateSSOAdminPortalRedirect(
    orgId: string,
    redirectUrl: string,
    auth: AuthCredentials,
): Promise<SSOAdminPortalResponse> {
    return generateAdminPortalRedirect(orgId, redirectUrl, auth, 'accessAdminPortal');
}

export function generateDirectorySyncAdminPortalRedirect(
    orgId: string,
    redirectUrl: string,
    auth: AuthCredentials,
): Promise<SSOAdminPortalResponse> {
    return generateAdminPortalRedirect(orgId, redirectUrl, auth, 'accessDirectorySyncAdminPortal');
}

function generateAdminPortalRedirect(
    orgId: string,
    redirectUrl: string,
    auth: AuthCredentials,
    pathComponent: string,
): Promise<SSOAdminPortalResponse> {
    const orgUrl = orgEndpoint(orgId);
    const queryParams = {
        return_url: redirectUrl,
    };
    const encodedParams = qs.stringify(queryParams);
    const url = `${orgUrl}/sso/${pathComponent}?${encodedParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function logout(auth: AuthCredentials): Promise<void> {
    const url = `${USER_ENDPOINT}/logout`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function forgotPassword(request: ForgotPasswordRequest): Promise<void> {
    return runwayFetchWithoutAuth(
        RunwayEndpoint.ForgotPassword,
        ApiRequestType.post,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

/*****************************
 Sign up
 *****************************/

export function signUp(request: SignUpRequest): Promise<AuthResponse> {
    const url = `api/signup`;

    return runwayFetchWithoutAuth(url, ApiRequestType.post, jsonBaseHeaders, JSON.stringify(request));
}

/*****
 Org endpoints
 *****/

export function inviteTeam(request: InviteTeamRequest, auth: AuthCredentials): Promise<void> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/inviteFriends`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateReleasePlanningSummary(
    request: UpdateReleasePlanningSummaryRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/releasePlanningSummary`;
    const body = {
        releasePlanningSummary: request.releasePlanningSummary,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function createReleaseBranch(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/releaseBranch`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function promoteBranch(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/vcs/promoteBranch`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function bumpVersion(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);
    const url = `${releaseUrl}/vcs/bumpVersion`;
    const body = { ...rest };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function createNewRelease(request: NewReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const { orgId, appId, ...rest } = request;
    const body = rest;

    const appUrl = appEndpoint(orgId, appId);
    const path = `${appUrl}/release`;

    return runwayFetchWithAuth(path, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateRelease(request: UpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    const body = {
        releaseType: request.releaseType,
        version: request.version,
        releasePilotId: request.releasePilotId,
        targetKickoffDate: request.targetKickoffDate,
        targetSubmitDate: request.targetSubmitDate,
        targetReleaseDate: request.targetReleaseDate,
        releaseName: request.releaseName,
        shouldMatchPreviousPhasedRelease: request.shouldMatchPreviousPhasedRelease,
    };

    return runwayFetchWithAuth(releaseUrl, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteRelease(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<unknown> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    return runwayFetchWithAuth(releaseUrl, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function skipRelease(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const endpointUrl = `${releaseUrl}/skip`;
    return runwayFetchWithAuth(endpointUrl, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function unskipRelease(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const endpointUrl = `${releaseUrl}/unskip`;
    return runwayFetchWithAuth(endpointUrl, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function completeRelease(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const endpointUrl = `${releaseUrl}/complete`;
    return runwayFetchWithAuth(endpointUrl, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function uncompleteRelease(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const endpointUrl = `${releaseUrl}/uncomplete`;
    return runwayFetchWithAuth(endpointUrl, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function updateReleaseSummaryMessage(
    request: UpdateCustomizedReleaseSummaryMessageRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/releaseSummaryMessage`;

    const body = {
        message: request.message,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateRegressionStatusForReleaseStep(
    request: UpdateRegressionStatusRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/regressionStatus`;

    const body = {
        userId: request.userId,
        appId: request.appId,
        status: request.status,
        buildHash: request.buildHash,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function addBetaNotesForBetaBuild(
    request: CreateOrUpdateBetaBuildLocalizationsRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/betaBuildLocalizations`;
    const body = {
        buildId: request.buildId,
        localizations: request.localizations,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateMultiLocaleTestingNotes(
    request: CreateOrUpdateBetaBuildLocalizationsRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/betaBuildLocalizations`;
    const body = {
        buildId: request.buildId,
        localizations: request.localizations,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateBetaBuildNotes(
    request: CreateOrUpdateBetaBuildLocalizationsRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/betaBuildLocalizations`;
    const body = {
        buildId: request.buildId,
        localizationId: request.localizationId,
        localizations: request.localizations,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addIndividualTesterToBuild(
    request: AddIndividualTesterToBuildRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/assignBetaTester/${request.testerId}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function addBetaGroupToBuild(request: AddBetaGroupsToBuildRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/assignBetaGroups`;
    const body = {
        betaGroupsIds: request.groupIds,
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function submitBetaBuildForReview(
    request: SubmitBetaBuildForReviewRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/build/${request.buildId}/reviewSubmission`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function promoteBuildToTestingTrack(
    request: PromoteToTestingTrackRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);
    const url = `${releaseUrl}/beta/promoteBuilds`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateScreenshotsApprovalForReleaseStep(
    request: UpdateScreenshotsApprovalRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/screenshotsApproval`;
    const body = {
        userId: request.userId,
        appId: request.appId,
        isApproved: request.isApproved,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function updateMetadataApproval(
    request: UpdateMetadataApprovalRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/metadataApproval`;
    const body = {
        userId: request.userId,
        appId: request.appId,
        isApproved: request.isApproved,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function updateTranslationsApproval(
    resourceIds: BaseUpdateReleaseStepRequest,
    request: UpdateTranslationsApprovalRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/translations/approval`;
    const jsonBody = {
        userId: request.userId,
        appId: resourceIds.appId,
        isApproved: request.isApproved,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(jsonBody));
}

export function addReviewSubmissionItemForReleaseStep(
    request: UpdateReviewSubmissionItemRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/reviewSubmissions/item`;
    const jsonBody = {
        itemId: request.itemId,
        type: request.type,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(jsonBody));
}

export function removeReviewSubmissionItemForReleaseStep(
    request: UpdateReviewSubmissionItemRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/reviewSubmissions/item`;
    const jsonBody = {
        itemId: request.itemId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(jsonBody));
}

export function unblockReleaseReviewSubmissionForReleaseStep(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/unblockSubmission`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders);
}

export function cancelReleaseReviewSubmissionForReleaseStep(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/cancelSubmission`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders);
}

export function deleteScreenshotForReleaseStep(
    request: DeleteScreenshotRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/screenshots/delete`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteAppPreview(request: DeleteAppPreviewRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appPreviews/delete`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateReleaseNotes(
    request: UpdateReleaseNotesRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/metadata/update`;
    const jsonBody = {
        localizations: request.localizations,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(jsonBody));
}

export function releaseStepEndBetaSoak(
    request: ReleaseStepEndBetaSoakRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/endBetaTestingSoakPeriod`;
    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders);
}

export function endBetaSoak(
    resourceIds: StepRunEntityRequest,
    request: EndBetaSoakRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/endBetaTestingSoakPeriod`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function assignBetaGroupsToBuild(
    resourceIds: StepRunEntityRequest,
    request: AssignBetaGroupsToBuildRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/assignBetaGroupsToBuild`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function submitBetaBuildToReview(
    resourceIds: StepRunEntityRequest,
    request: SubmitBetaBuildToReviewRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/submitBetaBuildToReview`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function promoteBuildsToTestingTrack(
    resourceIds: StepRunEntityRequest,
    request: SubmitBetaBuildToReviewRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/promoteBuilds`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function assignBetaTester(
    resourceIds: StepRunEntityRequest,
    request: SubmitBetaBuildToReviewRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/assignBetaTester`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function createOrUpdateLocalizationNotesForBuild(
    resourceIds: StepRunEntityRequest,
    request: CreateOrUpdateBuildLocalizationsRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunEndpoint(resourceIds);
    const url = `${stepRunUrl}/betaBuildLocalizations`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function createStepRunChecklistItem(
    resourceIds: StepRunEntityRequest,
    request: CreateChecklistItemRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = stepRunChecklistItemEndpoint({ ...resourceIds, checklistItemId: null });
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateStepRunChecklistItem(
    resourceIds: StepRunChecklistItemEntityRequest,
    request: UpdateChecklistItemRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = stepRunChecklistItemEndpoint(resourceIds);
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteStepRunChecklistItem(
    resourceIds: StepRunChecklistItemEntityRequest,
    request: never,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = stepRunChecklistItemEndpoint(resourceIds);
    return runwayFetchWithAuthV2(url, ApiRequestType.delete, auth);
}

export function updateChecklistItemComment(
    resourceIds: StepRunChecklistItemEntityRequest,
    request: UpdateChecklistItemCommentRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunChecklistItemEndpoint(resourceIds);
    const url = `${stepRunUrl}/comment`;
    return runwayFetchWithAuthV2(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function pingChecklistItem(
    resourceIds: StepRunChecklistItemEntityRequest,
    request: UpdateChecklistItemCommentRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunChecklistItemEndpoint(resourceIds);
    const url = `${stepRunUrl}/ping`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function pingPendingChecklistItems(
    resourceIds: StepRunEntityRequest,
    request: UpdateChecklistItemCommentRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunChecklistItemEndpoint({ ...resourceIds, checklistItemId: null });
    const url = `${stepRunUrl}/pingAllPending`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateChecklistItemStatus(
    resourceIds: StepRunChecklistItemEntityRequest,
    request: UpdateChecklistItemStatusRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepRunUrl = stepRunChecklistItemEndpoint(resourceIds);
    const url = `${stepRunUrl}/status`;
    return runwayFetchWithAuthV2(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function releaseStepUpdateChecklistItemStatus(
    request: UpdateChecklistItemStatusRequest,
    auth: AuthCredentials,
): Promise<ChecklistItemUpdatableAPIResponse> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/checklistItem/${request.checklistSettingId}/status`;
    const body = {
        status: request.status,
        userId: request.userId,
        appId: request.appId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function releaseStepUpdateChecklistItemComment(
    request: UpdateReleaseStepChecklistItemCommentRequest,
    auth: AuthCredentials,
): Promise<ChecklistItemUpdatableAPIResponse> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/checklistItem/${request.checklistSettingId}/comment`;
    const body = {
        comment: request.comment,
        userId: request.userId,
        appId: request.appId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function pingChecklistItemOwners(
    request: PingChecklistItemOwnersRequest,
    auth: AuthCredentials,
): Promise<unknown> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/cliPing/${request.checklistItemId}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function pingAllChecklistItemOwners(
    request: PingAllChecklistItemOwnersRequest,
    auth: AuthCredentials,
): Promise<unknown> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/cliPingAll`;
    const body = {
        placement: request.placement,
        releaseStep: request.releaseStep,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function tagReleaseReleaseStep(request: TagReleaseRequestReleaseStep, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/tag`;
    const body = {
        commitHash: request.commitHash,
        tagName: request.tagName,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function getPreviousReleaseNotes(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<LocalizedMetadata[]> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/getPreviousReleaseNotes`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function generateReleaseNotes(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
    notesType: GeneratedReleaseNotesType,
    stepContext: GeneratedReleaseNotesStepContext,
    markdownContext: GeneratedReleaseNotesMarkdownContext,
    locale: string,
    additionalUserContext?: string,
): Promise<GeneratedReleaseNotesResponse> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    if (additionalUserContext !== undefined && additionalUserContext !== '') {
        const url = `${releaseUrl}/generateReleaseNotes`;
        const body = {
            notesType,
            stepContext,
            markdownContext,
            locale: locale && locale !== '' ? locale : 'en-US',
            additionalUserContext,
        };
        return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
    }

    const baseUrl = `${releaseUrl}/generateReleaseNotes?notesType=${notesType}&stepContext=${stepContext}&markdownContext=${markdownContext}`;
    const fullUrl = locale && locale != '' ? `${baseUrl}&locale=${locale}` : baseUrl;

    return runwayFetchWithAuth(fullUrl, ApiRequestType.get, auth);
}

/*****
 * ORG SETTINGS
 */

export function updateMergeAccountsSetting(
    request: UpdateMergeAccountsSettingRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/updateMergeAccountsWithAllowedDomainsSetting`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function activateSubscriptionTrial(
    request: BaseUpdateOrgSettingsRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/activateSubscriptionTrial`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateUser(request: UpdateUserRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const orgUserUrl = orgEndpoint(request.orgId);
    const url = `${orgUserUrl}/user/${request.userId}`;

    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function removeOrgUser(request: RemoveOrgUserRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const orgUserUrl = orgEndpoint(request.orgId);
    const url = `${orgUserUrl}/user/${request.userId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function removeUserDevice(request: UpdateUserRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const orgUserUrl = orgEndpoint(request.orgId);
    const url = `${orgUserUrl}/devices`;

    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateUserGroupsToCommsGroupMapForProviderId(
    request: UpdateProviderIdToUserGroupsToCommsGroupsMapRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const { orgId, ...rest } = request;
    const orgUrl = orgEndpoint(orgId);

    const url = `${orgUrl}/userRolesToCommsGroups`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

/*****
 * APP SETTINGS
 */

export function updateNotificationSettings(
    request: UpdateNotificationSettingsRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateNotification/${request.notificationId}`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateStepNotificationConfig(
    request: UpdateStepNotificationConfigRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const url = `${stepConfigEndpoint({ orgId: request.orgId, workflowId: request.workflowId, stepConfigId: request.stepConfigId })}/notification/${request.notificationId}`;
    const body = {
        enabled: request.enabled,
        settings: request.settings,
        channels: request.channels,
    };
    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteStepNotificationConfig(
    request: DeleteStepNotificationConfigRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const url = `${stepConfigEndpoint({ orgId: request.orgId, workflowId: request.workflowId, stepConfigId: request.stepConfigId })}/notification/${request.notificationId}`;
    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function addReleasePilots(request: AddReleasePilotsRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/addReleasePilots`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function removeReleasePilot(request: RemoveReleasePilotRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/removeReleasePilot`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateReleasePilotsOrder(
    request: UpdateReleasePilotsOrderRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/releasePilots`;
    const body = {
        releasePilotRotation: request.releasePilotRotation,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateQualitativeOnboardingStatus(
    request: UpdateQualitativeOnboardingStatusRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateQualitativeOnboardingStatus`;
    const body = {
        isComplete: request.isComplete,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateReleaseScheduleCadenceSettings(
    request: ReleaseScheduleCadenceSettingsRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/automation/scheduleCadence`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateReleaseStepAutomationSettings(
    request: UpdateAutomationSettingsRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/automation/${request.automationId}`;
    const body = {
        enabled: request.enabled,
        data: request.data,
        configPerReleaseType: request.configPerReleaseType,
        automationReleaseTypes: request.automationReleaseTypes,
        releaseId: request.releaseId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addNewFeatureAffiliation(
    request: NewFeatureAffiliationRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/featureAffiliation`;
    const body = {
        orgId: request.orgId,
        integrationId: request.integrationId,
        affiliationType: request.affiliationType,
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function deleteFeatureAffiliation(
    request: DeleteFeatureAffiliationRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/featureAffiliation/${request.featureAffiliationId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, formEncodedBaseHeaders);
}

export function updateFeatureAffiliationPattern(
    request: UpdateFeatureAffiliationPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/featureAffiliation/${request.featureAffiliationId}`;
    const body = {
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function updateTranslationDirectories(
    request: UpdateTranslationDirectoriesRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateTranslationDirectories`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBumpVersionOverrideFiles(
    request: UpdateBumpVersionOverrideFilesRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateBumpVersionOverrideFiles`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function getDefaultTranslationDirectories(
    request: BaseAppRequest,
    auth: AuthCredentials,
): Promise<TranslationDirectory[]> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/getDefaultTranslationDirectories`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getDefaultBumpVersionFiles(request: BaseAppRequest, auth: AuthCredentials): Promise<BumpVersionFile[]> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/getDefaultBumpVersionFiles`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function scanRepository(request: BaseAppRequest, auth: AuthCredentials): Promise<ScanResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/scanRepository`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function generateQuickStartCIFilesiOS(
    request: GenerateQuickStartCIFilesRequest,
    auth: AuthCredentials,
): Promise<QuickStartCIFilesResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/generateQuickstartCIResultFiles/ios`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function generateQuickStartCIFilesAndroid(
    request: GenerateQuickStartCIFilesRequest,
    auth: AuthCredentials,
): Promise<QuickStartCIFilesResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/generateQuickstartCIResultFiles/android`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function openPRForQuickStartCIFiles(
    request: OpenPRForQuickStartCIFilesRequest,
    auth: AuthCredentials,
): Promise<OpenPRQuickstartResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/generateQuickstartCIResultFiles/openPR`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function getProvisioningProfiles(
    request: BaseAppRequest,
    auth: AuthCredentials,
): Promise<GetProvisioningProfilesResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/profiles`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function updateNonBlockingSteps(
    request: UpdateNonBlockingStepsRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateNonBlockingSteps`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateFilterPaths(request: UpdateFilterPathsRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/codeFilterPaths`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function getCandidateSelectableCommits(
    request: GetCandidateSelectableCommitsRequest,
    auth: AuthCredentials,
): Promise<CandidateSelectableCommits> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    let url = `${appUrl}/candidateSelectableCommits`;

    if (request.commitHash) {
        url += `?commitHash=${request.commitHash}`;
    } else if (request.version) {
        url += `?headVersion=${request.version}`;
    }

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getAppRepoContributors(
    request: GetAppRepoContributorsRequest,
    auth: AuthCredentials,
): Promise<RepoContributors> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const bucketId = request.bucketId;
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/repoContributors`;
    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function tagCommit(request: TagCommitRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/tagCommit`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function releaseStepCreateChecklistItem(
    request: ReleaseStepNewChecklistItemRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const { orgId, appId, ...rest } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/checklistItem`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function releaseStepDeleteChecklistItem(
    request: ReleaseStepDeleteChecklistItemRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/checklistItem/${request.checklistItemId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export function updateCustomMessagesTemplates(
    request: UpdateCustomMessagesTemplatesRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const { orgId, appId, ...rest } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/customMessageTemplates`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function refreshIntegrationRefreshData(
    request: BaseAppRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const { orgId, appId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/integrationInfo`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth, jsonBaseHeaders);
}

export function releaseStepUpdateChecklistItem(
    request: ReleaseStepUpdateChecklistItemRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const { orgId, appId, ...rest } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/checklistItem/${request.checklistItemId}`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addAppUsers(request: UpdateAppUsersRequest, auth: AuthCredentials): Promise<AppSettingsV2APIResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/appUsers`;
    const body = {
        userIds: request.userIds,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function removeAppUsers(
    request: UpdateAppUsersRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/appUsers`;
    const body = {
        userIds: request.userIds,
    };

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateChecklistItemsOrder(
    request: UpdateChecklistItemsOrderRequest,
    auth: AuthCredentials,
): Promise<AppSettingsV2APIResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/checklistItems`;
    const body = {
        orderedItemIds: request.orderedItemIds,
        releaseId: request.releaseId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function createReleaseBranchPattern(
    request: NewReleaseBranchPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseBranchPattern`;
    const body = {
        orgId: request.orgId,
        isHotfix: request.isHotfix,
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(
        url,
        ApiRequestType.post,
        auth,
        formEncodedBaseHeaders,
        formurlencoded(body, { ignorenull: true }),
    );
}

export function getSuggestedReleaseBranchPattern(request: AppEntityRequest, auth: AuthCredentials): Promise<string> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseBranchPattern/guess`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function updateReleaseBranchPattern(
    request: UpdateReleaseBranchPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseBranchPattern/${request.branchPatternId}`;
    const body = {
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function deleteReleaseBranchPattern(
    request: DeleteReleaseBranchPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseBranchPattern/${request.branchPatternId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, formEncodedBaseHeaders);
}

export function updateAdditionalBranches(
    request: SetAdditionalBranchesRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/extraBranches`;
    const body = {
        workingBranch: request.workingBranch,
        stagingBranch: request.stagingBranch,
        prodBranch: request.prodBranch,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function getSuggestedWorkingBranch(request: AppEntityRequest, auth: AuthCredentials): Promise<string> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/workingBranch/guess`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function addNewWebhook(request: AddNewWebhookRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const { orgId } = request;

    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/webhooks`;

    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateWebhook(request: UpdateWebhookRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const { orgId, webhookId } = request;

    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/webhooks/${webhookId}`;

    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteWebhook(request: DeleteWebhookRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const { orgId, webhookId } = request;

    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/webhooks/${webhookId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function addPublicApiKey(request: AddApiKeyRequest, auth: AuthCredentials): Promise<CreatePublicApiKeyResponse> {
    const { orgId } = request;

    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/apiKey`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deletePublicApiKey(request: DeleteApiKeyRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const { orgId, apiKeyId } = request;

    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/apiKey/${apiKeyId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export interface APIKeyUsageStats {
    keyId: string;
    used: number;
    limit: number;
}

export function getApiKeyUsage(orgId: string, auth: AuthCredentials): Promise<APIKeyUsageStats[]> {
    const appUrl = orgEndpoint(orgId);
    const url = `${appUrl}/apiKeyUsage`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function updateAddNewUsersToAppsSetting(
    request: UpdateAddNewUsersToAppsSettingRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const { orgId } = request;

    const appUrl = orgEndpoint(orgId);

    const url = `${appUrl}/addNewUsersToAppsSetting`;
    const body = {
        addNewUsersToAppsSettingEnabled: request.addNewUsersToAppsSettingEnabled,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateOrgTimezone(
    request: UpdateOrgTimezoneRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const { orgId } = request;

    const appUrl = orgEndpoint(orgId);

    const url = `${appUrl}/timezone`;
    const body = {
        timezone: request.timezone,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateAISettings(request: UpdateAISettingsRequest, auth: AuthCredentials): Promise<OrganizationEntity> {
    const { orgId, ...body } = request;
    const url = `${orgEndpoint(orgId)}/aiSettings`;
    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateUserGroupsForDirectorySyncGroup(
    request: UpdateUserGroupsForDirectorySyncGroupRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/sso/rolesForGroup`;
    const body = {
        groupId: request.groupId,
        userGroups: request.userGroups,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

// *** APP ENDPOINTS **** //

export function createApp(request: CreateAppRequest, auth: AuthCredentials): Promise<CreateAppApiResponse[]> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/createApp`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addApps(request: AddAppsRequest, auth: AuthCredentials): Promise<CreateAppApiResponse[]> {
    const orgUrl = orgEndpoint(request.orgId);

    const url = `${orgUrl}/addApps`;
    const body = request.appsToAdd;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteApp(request: DeleteAppRequest, auth: AuthCredentials): Promise<void> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    return runwayFetchWithAuth(appUrl, ApiRequestType.delete, auth);
}

// Update App Store release defaults

export function updateAppleAppStoreReleaseDefaults(
    request: UpdateAppleAppStoreReleaseDefaults,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/appStore/defaultSettings`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateGoogleAppStoreReleaseDefaults(
    request: UpdatePlayAppStoreReleaseDefaults,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/appStore/defaultSettings`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateHuaweiAppStoreReleaseDefaults(
    request: UpdateHuaweiAppStoreReleaseDefaults,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/appStore/defaultSettings`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

/** User Endpoints */

export function getOrgsForUser(auth: AuthCredentials): Promise<UserOrgsResponse[]> {
    const url = `api/user/orgs`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// Set App Store default release notes

export function updateAppStoreDefaultReleaseNotes(
    request: UpdateDefaultReleaseNotes,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/appStore/defaultMetadata`;
    const body = {
        defaultReleaseNotes: request.defaultReleaseNotes,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateVersioningDefaults(
    request: UpdateVersioningDefaultsRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const { orgId, appId, ...rest } = request;
    const appUrl = appEndpoint(orgId, appId);

    const url = `${appUrl}/versioningDefaults`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function uploadDefaultReviewAttachment(
    request: UploadDefaultReviewAttachmentRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/appStore/defaultReviewAttachmentFile`;
    const file = request.file;
    const formData = new FormData();

    formData.append('file', file);

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, null, formData);
}

export function uploadChecklistAttachments(
    orgId: string,
    workflowId: string,
    files: File[],
    auth: AuthCredentials,
): Promise<RunwayResponseV2<ChecklistAttachment[]>> {
    const url = `${workflowEndpoint({ orgId, workflowId })}/checklistAttachments`;
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, null, formData);
}

export function getChecklistAttachmentURLs(
    orgId: string,
    workflowId: string,
    s3Keys: string[],
    auth: AuthCredentials,
): Promise<RunwayResponseV2<Record<string, string>>> {
    const url = `${workflowEndpoint({ orgId, workflowId })}/checklistAttachmentURLs`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify({ s3Keys }));
}

export function removeDefaultReviewAttachment(
    request: RemoveDefaultReviewAttachmentRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/appStore/defaultReviewAttachmentFile/${request.fileName}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export function createReleaseTagPattern(
    request: NewReleaseTagPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseTagPattern`;
    const body = {
        orgId: request.orgId,
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function getSuggestedReleaseTagPattern(request: AppEntityRequest, auth: AuthCredentials): Promise<string> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseTagPattern/guess`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function updateReleaseTagPattern(
    request: UpdateReleaseTagPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseTagPattern/${request.tagPatternId}`;
    const body = {
        pattern: request.pattern,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, formEncodedBaseHeaders, formurlencoded(body));
}

export function updateUserRolesMap(request: UpdateUserRolesMapRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/rolesMap`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request.rolesMap));
}

export function triggerIntegrationRefresh(
    request: TriggerIntegrationRefreshRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/refresh/${request.integrationId}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

// provisioning and devices

export function addDevice(request: AddDeviceRequest, auth: AuthCredentials): Promise<GetAllDevicesResponse> {
    const { orgId, appId, ...rest } = request;
    const appUrl = appEndpoint(orgId, appId);

    const url = `${appUrl}/devices`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function saveUserEmailNotificationSettings(
    request: UpdateUserEmailNotificationSettingsRequest,
    auth: AuthCredentials,
): Promise<UpdateUserEmailNotificationSettingsRequest> {
    const { orgId, ...rest } = request;
    const orgUrl = orgEndpoint(orgId);

    const url = `${orgUrl}/userEmailNotificationSettings`;

    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addUserDevice(request: AddUserDeviceRequest, auth: AuthCredentials): Promise<User> {
    const orgUserUrl = orgEndpoint(request.orgId);
    const url = `${orgUserUrl}/devices`;

    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function verifyCommsUser(request: VerifyCommsUserRequest, auth: AuthCredentials): Promise<void> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/verifyCommsUser`;

    const body = {
        teamId: request.teamId,
        commsUserId: request.commsUserId,
        code: request.code,
        integrationType: request.integrationType,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export interface RequestCommsUserVerificationRequest {
    orgId: string;
    commsUserId: string;
    providerId: string;
    integrationType: string;
}

export interface RequestCommsUserVerificationResponse {
    verificationLink?: string;
}

export function requestCommsUserVerification(
    request: RequestCommsUserVerificationRequest,
    auth: AuthCredentials,
): Promise<RequestCommsUserVerificationResponse | null> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/requestCommsUserVerification`;
    const body = {
        commsUserId: request.commsUserId,
        providerId: request.providerId,
        integrationType: request.integrationType,
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export interface CommsUserForVerification {
    id: string;
    email: string;
    displayName: string;
}

export function getCommsUsersForVerification(
    orgId: string,
    providerId: string,
    integrationType: string,
    auth: AuthCredentials,
): Promise<CommsUserForVerification[]> {
    const orgUrl = orgEndpoint(orgId);
    const url = `${orgUrl}/commsUsersForVerification?providerId=${encodeURIComponent(providerId)}&integrationType=${encodeURIComponent(integrationType)}`;
    return runwayFetchWithAuth(url, ApiRequestType.get, auth, jsonBaseHeaders);
}

export function deleteSigningKey(request: DeleteSigningKeyRequest, auth: AuthCredentials): Promise<AppSettings> {
    const { orgId, appId, keyId } = request;
    const appUrl = appEndpoint(orgId, appId);

    const url = `${appUrl}/appStore/signingKey/${keyId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function updateSigningKey(request: UpdateSigningKeyRequest, auth: AuthCredentials): Promise<AppSettings> {
    const { orgId, appId, keyId, ...rest } = request;
    const appUrl = appEndpoint(orgId, appId);

    const url = `${appUrl}/appStore/signingKey/${keyId}`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

// Monitoring Metrics

export function updateMonitoringMetric(
    request: UpdateMonitoringMetricRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const { orgId, appId, ...body } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/monitoringMetric`;
    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addMonitoringMetric(request: AddMonitoringMetricRequest, auth: AuthCredentials): Promise<AppSettings> {
    const { orgId, appId, ...body } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/monitoringMetric`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteMonitoringMetric(
    request: DeleteMonitoringMetricRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const { orgId, appId, ...body } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/monitoringMetric`;
    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function deleteReleaseTagPattern(
    request: DeleteReleaseTagPatternRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/releaseTagPattern/${request.tagPatternId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, formEncodedBaseHeaders);
}

export function releaseStepUpdateBetaStyle(
    request: UpdateBetaStyleRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/betaTestingStyle`;
    const body = {
        betaTestingStyle: request.betaTestingStyle,
        prescribedBetaSoakDurationSeconds: request.prescribedBetaSoakDurationSeconds,
    };

    return runwayFetchWithAuth(
        url,
        ApiRequestType.put,
        auth,
        formEncodedBaseHeaders,
        formurlencoded(body, { ignorenull: true }),
    );
}

export function updateBetaTestingStyle(
    resourceIds: StepConfigEntityRequest,
    request: UpdateBetaTestingStyleRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepUrl = stepConfigEndpoint(resourceIds);
    const url = `${stepUrl}/betaTestingStyle`;

    return runwayFetchWithAuthV2(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function releaseStepUpdateRegressionTestingStrategy(
    request: UpdateRegressionTestingStrategyRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/regressionTestingStrategy`;
    const body = {
        regressionTestingStrategy: request.regressionTestingStrategy,
    };

    return runwayFetchWithAuth(
        url,
        ApiRequestType.put,
        auth,
        formEncodedBaseHeaders,
        formurlencoded(body, { ignorenull: true }),
    );
}

export function updateRegressionTestingStrategy(
    resourceIds: StepConfigEntityRequest,
    request: UpdateRegressionTestingStrategyRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepUrl = stepConfigEndpoint(resourceIds);
    const url = `${stepUrl}/regressionTestingStrategy`;

    return runwayFetchWithAuthV2(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function createChecklistItemTemplate(
    resourceIds: StepConfigEntityRequest,
    request: CreateChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = checklistItemTemplateEndpoint({ ...resourceIds, checklistItemId: null });
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateChecklistItemTemplate(
    resourceIds: ChecklistItemTemplateEntityRequest,
    request: UpdateChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = checklistItemTemplateEndpoint(resourceIds);
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteChecklistItemTemplate(
    resourceIds: ChecklistItemTemplateEntityRequest,
    request: DeleteChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = checklistItemTemplateEndpoint(resourceIds);
    return runwayFetchWithAuthV2(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function updateChecklistItemTemplateOrder(
    resourceIds: ChecklistItemTemplateEntityRequest,
    request: UpdateChecklistItemTemplateOrderRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepUrl = stepConfigEndpoint(resourceIds);
    const url = `${stepUrl}/checklistItemsOrder`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateAutomationSettings(
    resourceIds: AutomationEntityRequest,
    request: UpdateAutomationSettingsRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = automationEndpoint(resourceIds);
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

// Creates a new integration associated with the app, or updates the authorization of an existing integration

export function createIntegration(
    request: CreateIntegrationRequest,
    auth: AuthCredentials,
): Promise<CreateDeleteIntegrationResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/integration`;
    const body = {
        integrationId: request.integrationId,
        data: request.data,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function createQuickStartIntegration(
    request: CreateIntegrationRequest,
    auth: AuthCredentials,
): Promise<CreateAppAddIntegrationResponse> {
    const orgUrl = orgEndpoint(request.orgId);

    const url = `${orgUrl}/integration`;
    const body = {
        integrationId: request.integrationId,
        data: request.data,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateIntegration(request: UpdateIntegrationRequest, auth: AuthCredentials): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/integration`;
    const body = {
        integrationId: request.integrationId,
        data: request.data,
        isPartialUpdate: request.isPartialUpdate ?? false,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateIntegrationAlias(
    request: UpdateIntegrationAliasRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/integration/${request.integrationId}/alias`;
    const body = { alias: request.alias };

    return runwayFetchWithAuth(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function refreshIntegration(
    request: RefreshIntegrationRequest,
    auth: AuthCredentials,
): Promise<CreateAppAddIntegrationResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/integration/${request.integrationId}/refreshProvider`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders);
}

export function deleteIntegration(
    request: IntegrationRequest,
    auth: AuthCredentials,
): Promise<CreateDeleteIntegrationResponse> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const url = `${appUrl}/integration/${request.integrationId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export function bulkRegisterDevices(
    request: UpdateDevicesRequest,
    auth: AuthCredentials,
): Promise<GetAllDevicesResponse> {
    const { orgId, appId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/devices/bulkRegister`;

    const body = {
        deviceIds: request.deviceIds,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function bulkEnableDisableDevices(
    request: EnableDisableDevicesRequest,
    auth: AuthCredentials,
): Promise<GetAllDevicesResponse> {
    const { orgId, appId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/devices/bulkEnableDisable`;

    const body = {
        deviceIds: request.deviceIds,
        enable: request.enable,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function bulkDeleteDevices(
    request: UpdateDevicesRequest,
    auth: AuthCredentials,
): Promise<GetAllDevicesResponse> {
    const { orgId, appId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/devices`;

    const body = {
        deviceIds: request.deviceIds,
    };

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function validateReleaseVersion(
    request: ValidateReleaseVersionRequest,
    auth: AuthCredentials,
): Promise<NewVersionValidationResult> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const path = `${appUrl}/version/validate`;
    const params = {
        version: request.version,
        releaseId: request.releaseId,
        releaseType: request.releaseType,
        sourceVersion: request.sourceVersion,
    };

    return runwayFetchWithAuth(path, ApiRequestType.get, auth, {}, null, params);
}

export function getShortLivedToken(auth: AuthCredentials): Promise<string> {
    const url = 'api/artifact/token';

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getShortLivedWebsocketConnectionToken(auth: AuthCredentials): Promise<string> {
    const url = 'api/websocket/token';

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// Predicts the version of the next release in an app
export function predictReleaseVersion(request: PredictReleaseVersionRequest, auth: AuthCredentials): Promise<string> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const path = `${appUrl}/version/predict`;
    const params = {
        isHotfix: request.isHotfix,
    };

    return runwayFetchWithAuth(path, ApiRequestType.get, auth, {}, null, params);
}

export function getPossibleBaseTags(request: GetPossibleBaseTagsRequest, auth: AuthCredentials): Promise<ReleaseTag[]> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const path = `${appUrl}/tags`;

    return runwayFetchWithAuth(path, ApiRequestType.get, auth);
}

export function getPossibleSourceVersions(
    request: GetPossibleSourceVersionsForRollbackRequest,
    auth: AuthCredentials,
): Promise<string[]> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const path = `${appUrl}/possibleRollbackSourceVersions`;
    return runwayFetchWithAuth(path, ApiRequestType.get, auth);
}

/*************************
 RELEASE ENDPOINTS
 **************************/

// Pause schedule cadence

export function pauseScheduleCadence(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/automation/scheduleCadence/pause`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth);
}

// Resume schedule cadence

export function resumeScheduleCadence(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/automation/scheduleCadence/unpause`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth);
}

// Ignore/unignore FR item

export function ignoreUnignoreFRItem(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: IgnoreUnignoreFRItemRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const { orgId, appId, releaseId } = resourceIds;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);

    const path = `${releaseUrl}/fritem/ignoreUnignore`;

    return runwayFetchWithAuth(path, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

// Updates the selected build on ASC or the Play Console

export function updateSelectedBuild(request: UpdateSelectedBuildRequest, auth: AuthCredentials): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;

    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);

    const url = `${releaseUrl}/appStore/selectedBuilds`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateAdditionalSelectedBuilds(
    request: UpdateAdditionalSelectedBuildsRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;

    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);

    const url = `${releaseUrl}/appStore/additionalSelectedBuilds`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

// Updates setting on ASC
export function updateAppleAppStoreSettings(
    request: UpdateAppleAppStoreSettingsRequestForReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/settings`;
    const body = {
        releaseType: request.releaseType,
        earliestReleaseDate: request.earliestReleaseDate,
        phasedReleaseEnabled: request.phasedReleaseEnabled,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateGoogleReleaseSettings(
    request: UpdateGoogleAppStoreReleaseSettingsRequestForReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);
    const url = `${releaseUrl}/appStore/settings`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateHuaweiReleaseSettings(
    request: UpdateHuaweiAppStoreReleaseSettingsRequestForReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const { orgId, appId, releaseId, ...rest } = request;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);
    const url = `${releaseUrl}/appStore/settings`;
    const body = {
        ...rest,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

// Submit iOS binary or APK for review

export function submitAppForReviewReleaseStep(
    request: SubmitAppForReviewRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    const url = `${releaseUrl}/appStore/submit`;
    const body = {
        releasePreviousSubmissionToAllUsersFirst: request.releasePreviousSubmissionToAllUsersFirst,
        releaseBetaTrackToFullPercentagePriorToSubmission: request.releaseBetaTrackToFullPercentagePriorToSubmission,
        shouldMatchPreviousPhasedRelease: request.shouldMatchPreviousPhasedRelease,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

// Update phased release status

export function updateGooglePhasedRelease(
    request: UpdateGooglePhasedReleaseRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/phasedRelease`;
    const body = {
        userFraction: request.userFraction,
        phaseState: request.phaseState,
        resumeAutomations: request.resumeAutomations,
        actionType: request.actionType,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateHuaweiPhasedRelease(
    request: UpdateHuaweiPhasedReleaseRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/phasedRelease`;
    const body = {
        userFraction: request.userFraction,
        phaseState: request.phaseState,
        resumeAutomations: request.resumeAutomations,
        actionType: request.actionType,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateApplePhasedRelease(
    request: UpdateApplePhasedReleaseRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/phasedRelease`;
    const body = {
        phaseState: request.phaseState,
        resumeAutomations: request.resumeAutomations,
        actionType: request.actionType,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function markAndroidSubmissionRejectedReleaseStep(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/markRejected`;
    const body = {};

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function rejectVersion(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/rejectVersion`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function rejectAppleSubmissionForReleaseStep(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/reject`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders);
}

export function releaseAppleVersionForReleaseStep(
    request: ReleaseAppleVersionRequestReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/appStore/release`;
    const body = {
        releasePreviousSubmissionToAllUsersFirst: request.releasePreviousSubmissionToAllUsersFirst,
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function triggerBuildWorkflow(request: StartWorkflowRequest, auth: AuthCredentials): Promise<void> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/buildSystem/trigger`;
    const body = {
        workflowType: request.workflowType,
        ...(request.additionalWorkflowVariables &&
            Object.keys(request.additionalWorkflowVariables).length > 0 && {
                additionalWorkflowVariables: request.additionalWorkflowVariables,
            }),
    };

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function sendBinaryInstallLinkToComms(
    request: SendBinaryInstallLinkToCommsRequest,
    auth: AuthCredentials,
): Promise<void> {
    const { orgId, appId, artifactId } = request;
    const releaseUrl = appEndpoint(orgId, appId);
    const url = `${releaseUrl}/sendInstallLinkToComms?artifactId=${artifactId}&workflowRunId=${request.workflowRunId}&version=${request.version}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// ****** FETCH REQUESTS ******* /

// fetch app entity
export function getAppState(request: AppEntityRequest, auth: AuthCredentials): Promise<AppStateResponse> {
    const { orgId, appId } = request;
    const appStateUrl = appStateEndpoint(orgId, appId);

    return runwayFetchWithAuth(appStateUrl, ApiRequestType.get, auth);
}

// fetch release entity
export function getRelease(request: ReleaseEntityRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    return runwayFetchWithAuth(releaseUrl, ApiRequestType.get, auth);
}

export function getReleaseStep(request: ReleaseStepEntityRequest, auth: AuthCredentials): Promise<ReleaseStep> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/step/${request.releaseStepType}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getStepRun(request: StepRunEntityRequest, auth: AuthCredentials): Promise<RunwayResponseV2<StepRun>> {
    const stepRunUrl = stepRunEndpoint(request);
    return runwayFetchWithAuthV2<StepRun>(stepRunUrl, ApiRequestType.get, auth);
}

export function getStepRunsSummary(
    request: StepRunsSummaryEntityRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<RunwayModelsResponse>> {
    const stepRunsSummaryUrl = workflowRunEndpoint(request);
    const queryParams = {
        stepRunIds: request.stepRunIds.join(','),
    };
    const url = `${stepRunsSummaryUrl}/stepGroupSummary?${qs.stringify(queryParams)}`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(url, ApiRequestType.get, auth);
}

export function triggerBatchAction(
    resourceIds: WorkflowRunEntityRequest,
    request: TriggerBatchActionRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<RunwayModelsResponse>> {
    const workflowRunUrl = workflowRunEndpoint(resourceIds);
    const url = `${workflowRunUrl}/triggerBatchAction`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        url,
        ApiRequestType.post,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

export function updateDestinationStatuses(
    resourceIds: WorkflowRunEntityRequest,
    request: UpdateDestinationStatusesRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<RunwayModelsResponse>> {
    const workflowRunUrl = workflowRunEndpoint(resourceIds);
    const url = `${workflowRunUrl}/updateDestinationStatuses`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        url,
        ApiRequestType.post,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

export function getStepConfig(
    request: StepConfigEntityRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<StepConfig>> {
    const stepConfigUrl = stepConfigEndpoint(request);
    return runwayFetchWithAuthV2<StepConfig>(stepConfigUrl, ApiRequestType.get, auth);
}

export function getWorkflowOverview(
    request: WorkflowOverviewEntityRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<WorkflowOverview>> {
    let url = `${workflowEndpoint(request)}/overview`;

    const params: Record<string, string[]> = {};
    if (request.destinationStepIds?.length) params.destinationStepIds = request.destinationStepIds;
    if (request.excludedDestinationStepIds?.length)
        params.excludedDestinationStepIds = request.excludedDestinationStepIds;
    const encodedQueryParams = qs.stringify(params);
    if (encodedQueryParams) {
        url = `${url}?${encodedQueryParams}`;
    }

    return runwayFetchWithAuthV2<WorkflowOverview>(url, ApiRequestType.get, auth);
}

export function updateStepConfig(
    resourceIds: StepConfigEntityRequest,
    request: UpdateStepConfigRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const stepConfigUrl = stepConfigEndpoint(resourceIds);
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        stepConfigUrl,
        ApiRequestType.patch,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

export function updateDestinationDetails(
    resourceIds: BaseAppRequest & { destinationId: string },
    request: UpdateDestinationDetailsRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const appUrl = appEndpoint(resourceIds.orgId, resourceIds.appId);
    const url = `${appUrl}/destination/${resourceIds.destinationId}`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        url,
        ApiRequestType.patch,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

export function getCompletedReleases(
    request: ReleasesRequest,
    limit: number,
    offset: number,
    auth: AuthCredentials,
): Promise<Release[]> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const params = {
        limit,
        offset,
        status: 'completed,skipped', // hardcoded here for now, might consider moving to ReleasesRequest object in the future
    };

    const encodedQueryParams = qs.stringify(params);

    const url = `${appUrl}/releases?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// fetch app home
export function getAppHome(request: AppEntityRequest, auth: AuthCredentials): Promise<AppHome> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/appHome`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// fetch release stats
export function getReleaseStatsHistory(
    request: ReleaseEntityRequest,
    auth: AuthCredentials,
): Promise<ReleaseStatisticsHistory> {
    const appUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${appUrl}/releaseStats`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// fetch release overview
export function getReleaseOverview(
    request: ReleaseEntityRequest,
    auth: AuthCredentials,
): Promise<ReleaseStatisticsHistory> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/releaseOverview`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// fetch monitoring stats
export function getRolloutMonitoring(request: ReleaseEntityRequest, auth: AuthCredentials): Promise<RolloutMonitoring> {
    const appUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${appUrl}/rolloutMonitoring`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

// fetch build details
export function getBuildDetails(request: GetBuildDetailsRequest, auth: AuthCredentials): Promise<BuildDetails> {
    const baseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    const url = `${baseUrl}/buildDetails?secret=${request.buildDetailsSecret}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function toggleFeatureFlag(request: ToggleFeatureFlagRequest, auth: AuthCredentials): Promise<FeatureFlag> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const action = request.enable ? 'enable' : 'disable';
    const url = `${releaseUrl}/featureFlags/${request.featureFlagId}?action=${action}`;

    return runwayFetchWithAuth(url, ApiRequestType.patch, auth);
}

export function getFeatureFlags(request: ReleaseEntityRequest, auth: AuthCredentials): Promise<FeatureFlag[]> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/featureFlags`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getOrgOverviewV2(
    request: OrgOverviewEntityRequest<OrgOverviewFilters>,
    auth: AuthCredentials,
): Promise<OrgOverviewV2> {
    const { orgId, appIds, filters } = request;
    const orgUrl = orgEndpoint(orgId);

    const queryParams = {};

    if (appIds) {
        queryParams['appIds'] = appIds;
    }

    if (filters) {
        if (filters.endDate) {
            queryParams['endWindow'] = filters.endDate;
        }
        if (filters.startDate) {
            queryParams['startWindow'] = filters.startDate;
        }
    }

    const encodedQueryParams = qs.stringify(queryParams);

    const url = `${orgUrl}/v2/orgOverview?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function retryAppStoreArtifactUploadForReleaseStep(
    request: RetryAppStoreArtifactUploadRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/retryAppStoreUpload`;

    const body = {
        workflowRunId: request.workflowRunId,
        artifactId: request.artifactId,
        destinationInstallationId: request.destinationInstallationId,
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function retryDsymUpload(request: RetryDsymUploadRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/retryDsymUpload`;

    const body = {
        workflowRunId: request.workflowRunId,
        artifactId: request.artifactId,
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateReviewDetails(
    resourceIds: StepRunEntityRequest,
    request: UpdateReviewDetailsRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/updateReviewDetails`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateReviewDetailsForReleaseStep(
    request: UpdateReviewDetailsRequestForReleaseStep,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/updateReviewDetails`;
    const body = {
        ...request,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function addFixRequest(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: AddFixRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/addFixRequest`;
    const payload = {
        ...request,
        source: 'webApp',
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(payload));
}

export function updateFixRequest(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: UpdateFixRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/updateFixDetails`;

    return runwayFetchWithAuth(url, ApiRequestType.patch, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function approveFixRequest(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: ApproveFixRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/approveFix`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function rejectFixRequest(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: RejectFixRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/rejectFix`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function moveFixRequestToPendingApproval(
    resourceIds: BaseUpdateFeatureWorkItemRequest,
    request: MoveFixRequestToPendingApproval,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const url = `${releaseUrl}/moveFixToPending`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateFixesFeatureSettings(
    request: UpdateFixesFeatureSettingsRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateFixesFeatureSettings`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBundleSizeDeviceModel(
    request: UpdateBundleSizeDeviceModelRequest,
    auth: AuthCredentials,
): Promise<AppSettings> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/updateBundleSizeDeviceModel`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateOrgUserVCSUserName(
    request: UpdateOrgUserVCSUserNameRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/vcsUserName/${request.userId}`;
    const { vcsUserName, vcsProviderId } = request;
    const body = {
        vcsUserName,
        vcsProviderId,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateOrgUserTimezonePreference(
    request: UpdateOrgUserTimezonePreferenceRequest,
    auth: AuthCredentials,
) {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/timezonePreference/${request.userId}`;
    return runwayFetchWithAuth(
        url,
        ApiRequestType.put,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request.timezonePreference),
    );
}

export function createCustomGroup(
    request: CreateCustomGroupRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/groups`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateCustomGroup(
    request: UpdateCustomGroupRequest,
    auth: AuthCredentials,
): Promise<OrganizationEntity> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/groups`;
    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteCustomGroup(
    request: DeleteCustomGroupRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/groups`;
    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function exportTranslations(
    resourceIds: BaseUpdateReleaseStepRequest,
    request: ExportTranslationsRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const queryParams = {
        branchName: request.branchName,
    };

    const encodedParams = qs.stringify(queryParams);

    const url = `${releaseUrl}/translationKeys/export?${encodedParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function syncTranslations(
    resourceIds: BaseUpdateReleaseStepRequest,
    request: SyncTranslationsRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const queryParams = {
        branchName: request.branchName,
    };

    const encodedParams = qs.stringify(queryParams);

    const url = `${releaseUrl}/translationKeys/sync?${encodedParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function uploadTranslations(
    resourceIds: BaseUpdateReleaseStepRequest,
    request: UploadTranslationsRequest,
    auth: AuthCredentials,
): Promise<RunwayModelsResponse> {
    const releaseUrl = releaseEndpoint(resourceIds.orgId, resourceIds.appId, resourceIds.releaseId);
    const queryParams = {
        branchName: request.branchName,
    };

    const encodedParams = qs.stringify(queryParams);

    const url = `${releaseUrl}/translationKeys/upload?${encodedParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function uploadMetadataForTranslation(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/metadataTranslations/upload`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function exportMetadataTranslations(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/metadataTranslations/export`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

export function syncMetadataTranslations(request: BaseUpdateReleaseRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/metadataTranslations/sync`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders);
}

// select staging/rc build

export function selectReleaseCandidateBuild(request: SelectRCBuildRequest, auth: AuthCredentials): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);

    const url = `${releaseUrl}/selectedStagingBuild`;
    const body = {
        buildHash: request.buildHash,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function resumeAutoSelectLatestReleaseCandidateBuild(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/autoSelectRCBuild`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth);
}

export function startAutomatedStagedRollout(
    request: BaseUpdateReleaseRequest,
    auth: AuthCredentials,
): Promise<Release> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/startAutomatedStagedRollout`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth);
}

export function appStoreSearch(
    request: AppSearchRequest,
    auth: AuthCredentials,
    signal: AbortSignal,
): Promise<AppSearchResponse> {
    const queryParams = {
        countryCode: request.countryCode,
        searchQuery: request.queryString,
    };

    const encodedParams = qs.stringify(queryParams);
    const url = `api/appStoreSearch?${encodedParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth, null, null, null, signal);
}

// Admin endpoint

export function refreshIntegrations(request: BaseAppRequest, auth: AuthCredentials): Promise<void> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/integration/refresh`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

// Build distribution

const BuildDistributionPath = '/build-distribution';

export function fetchBuildDistributionBucketsWithRecentBuilds(
    request: BuildDistributionBucketsWithRecentBuildsEntityRequest,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketsWithRecentBuildsResponse> {
    const { orgId, appId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/recentBuilds`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function searchForBuildDistributionBuilds(
    request: BuildDistributionSearchBuildsEntityRequest,
    auth: AuthCredentials,
): Promise<BuildDistroBuild[]> {
    const { orgId, appId, query, bucketId } = request;

    const queryItems = { query };
    if (bucketId) {
        queryItems['bucketId'] = bucketId;
    }

    const queryParams = qs.stringify(queryItems);

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/search?${queryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionBucket(
    request: BuildDistributionBucketEntityRequest,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketResponse> {
    const { orgId, appId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionBucketBuild(
    request: BuildDistributionBucketBuildEntityRequest,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketBuildResponse> {
    const { orgId, appId, buildId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/builds/${buildId}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionBucketBuilds(
    request: BuildDistributionBucketBuildsEntityRequest,
    limit: number,
    offset: number,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketBuildsResponse> {
    const { orgId, appId, bucketId } = request;

    const params = {
        limit,
        offset,
    };

    const encodedQueryParams = qs.stringify(params);

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/builds?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistroJITResignStatus(
    request: { orgId: string; appId: string; buildId: string; bucketId: string },
    auth: AuthCredentials,
): Promise<{ data: { status: string }; success: boolean }> {
    const { orgId, appId, buildId, bucketId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/build/${buildId}/jit-resign-status?bucketId=${bucketId}`;
    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionBucketDownloadMetrics(
    request: BuildDistributionBucketDownloadMetricRequest,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketBuildResponse> {
    const { upperBound, lowerBound, orgId, appId, bucketId } = request;

    const encodedQueryParams = qs.stringify({
        upperBound,
        lowerBound,
    });

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/downloadMetrics?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionBuildWorkItemsTimeline(
    request: BuildDistributionBucketBuildsWorkItemsTimelineRequest,
    limit: number,
    offset: number,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionBucketBuildsWorkItemsTimelineResponse> {
    const { orgId, appId, bucketId, buildId } = request;

    const params = {
        limit,
        offset,
        buildId,
    };

    const encodedQueryParams = qs.stringify(params);

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/timeline?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function fetchBuildDistributionExternalBucket(
    request: FetchExternalBuildDistroBucketRequest,
): Promise<FetchExternalBuildDistroBucketResponse> {
    const { bucketHash } = request;
    const url = `api/bucket/${bucketHash}`;

    return runwayFetchWithoutAuth(url, ApiRequestType.get);
}

export function fetchBuildDistributionExternalBuild(
    request: FetchExternalBuildDistroBuildRequest,
): Promise<FetchExternalBuildDistroBuildResponse> {
    const { buildHash } = request;
    const url = `api/build/${buildHash}`;

    return runwayFetchWithoutAuth(url, ApiRequestType.get);
}

export function fetchBuildDistributionExternalBucketBuilds(
    request: FetchExternalBuildDistroBucketBuildsRequest,
): Promise<FetchExternalBuildDistroBucketBuildsResponse> {
    const { bucketHash } = request;
    const url = `api/bucket/${bucketHash}/builds`;

    return runwayFetchWithoutAuth(url, ApiRequestType.get);
}

export function getAllDevices(
    request: GetAllDevicesRequest,
    limit: number,
    offset: number,
    auth: AuthCredentials,
): Promise<GetAllDevicesResponse> {
    const { orgId, appId } = request;

    const params = {
        limit,
        offset,
        appId,
    };

    const encodedQueryParams = qs.stringify(params);

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}/devices?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function createBuildDistributionBucket(
    request: CreateBuildDistributionBucketRequest,
    auth: AuthCredentials,
): Promise<CreateBuildDistributionBucketResponse> {
    const { orgId, appId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBuildDistributionBucket(
    request: UpdateBuildDistributionBucketRequest,
    auth: AuthCredentials,
): Promise<UpdateBuildDistributionBucketResponse> {
    const { orgId, appId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${request.bucketId}`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function generateBinaryInstallLink(
    request: GenerateBinaryInstallLinkRequest,
    auth: AuthCredentials,
): Promise<string> {
    const { orgId, appId, artifactId } = request;
    const releaseUrl = appEndpoint(orgId, appId);
    const url = `${releaseUrl}/generateInstallLinkQRCode?artifactId=${artifactId}&workflowRunId=${request.workflowRunId}&version=${request.version}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function archiveBuildDistributionBucket(
    request: ArchiveBuildDistributionBucketRequest,
    auth: AuthCredentials,
): Promise<ArchiveBuildDistributionBucketResponse> {
    const { orgId, appId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export function updateBuildDistroBucketNotificationSettings(
    request: UpdateBuildDistroBucketNotificationSettingsRequest,
    auth: AuthCredentials,
): Promise<UpdateBuildDistroBucketNotificationSettingsResponse> {
    const { orgId, appId, bucketId, notificationId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/notifications/${notificationId}`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function toggleBuildDistroBucketNotifications(
    request: ToggleBuildDistroBucketNotificationsRequest,
    auth: AuthCredentials,
): Promise<ToggleBuildDistroBucketNotificationsResponse> {
    const { orgId, appId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/notifications`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBuildDistroBucketAutomationSettings(
    request: UpdateBuildDistroBucketAutomationSettingsRequest,
    auth: AuthCredentials,
): Promise<UpdateBuildDistroBucketAutomationsSettingsResponse> {
    const { orgId, appId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/automation/${request.automationId}`;
    const body = {
        enabled: request.enabled,
        data: request.data,
    };

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function shareBuildDistributionBuildWithTesters(
    request: ShareBuildDistributionBuildWithTestersRequest,
    auth: AuthCredentials,
): Promise<ShareBuildDistributionBuildWithTestersResponse> {
    const { orgId, appId, buildId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/build/${buildId}/individualTesters`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function fetchSharedWithMeBuildDistroBuilds(
    request: BuildDistributionSharedWithMeBuildsEntityRequest,
    limit: number,
    offset: number,
    auth: AuthCredentials,
): Promise<FetchBuildDistributionSharedWithMeBuildsResponse> {
    const { orgId, appId } = request;

    const params = {
        limit,
        offset,
    };

    const encodedQueryParams = qs.stringify(params);

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/sharedWithMe?${encodedQueryParams}`;

    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function enableBuildDistro(request: AppEntityRequest, auth: AuthCredentials): Promise<AppSettingsV2APIResponse> {
    const { orgId, appId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/enableBuildDistro`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBuildDistributionBuildTesterNotes(
    request: UpdateBuildDistributionBuildTesterNotesRequest,
    auth: AuthCredentials,
): Promise<UpdateBuildDistributionBuildTesterNotesResponse> {
    const { orgId, appId, buildId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/build/${buildId}/testerNotes`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function archiveBuildDistributionBuild(
    request: ArchiveBuildDistributionBuildRequest,
    auth: AuthCredentials,
): Promise<ArchiveBuildDistributionBuildResponse> {
    const { orgId, appId, buildId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/build/${buildId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function addBuildDistroBucketMembers(
    request: AddBuildDistroBucketMembersRequest,
    auth: AuthCredentials,
): Promise<BuildDistroBucketBase> {
    const { orgId, appId, bucketId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/members`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateBuildDistroBucketMemberPermissions(
    request: UpdateBuildDistroBucketMemberPermissionsRequest,
    auth: AuthCredentials,
): Promise<BuildDistroBucketBase> {
    const { orgId, appId, bucketId, memberId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/members/${memberId}`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function removeBuildDistroBucketMember(
    request: RemoveBuildDistroBucketMemberRequest,
    auth: AuthCredentials,
): Promise<BuildDistroBucketBase> {
    const { orgId, appId, bucketId, memberId } = request;

    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/members/${memberId}`;

    return runwayFetchWithAuth(url, ApiRequestType.delete, auth);
}

export function sendInstallLinkToMyselfOnComms(
    request: SendInstallLinkToMyselfRequest,
    auth: AuthCredentials,
): Promise<void> {
    const { orgId, appId, buildId, bucketId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/build/${buildId}/sendToMyself`;

    return runwayFetchWithAuth(url, ApiRequestType.put, auth);
}

export function triggerBuildDistributionBucketWorkflow(
    request: TriggerBuildDistributionBuildRequest,
    auth: AuthCredentials,
): Promise<void> {
    const { orgId, appId, bucketId } = request;
    const appUrl = appEndpoint(orgId, appId);
    const url = `${appUrl}${BuildDistributionPath}/bucket/${bucketId}/triggerBuild`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function startResignSequence(request: StartResignSequenceRequest, auth: AuthCredentials): Promise<Release> {
    const { orgId, appId, releaseId } = request;
    const releaseUrl = releaseEndpoint(orgId, appId, releaseId);
    const url = `${releaseUrl}/resignRollback`;

    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function startResignSequenceForStepRun(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/startResignProcess`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth);
}

export function updateSelectedBuildsInAppStore(
    resourceIds: StepRunEntityRequest,
    request: UpdateSelectedBuildsInAppStoreRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/selectedBuilds`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function submitAppForReview(
    resourceIds: StepRunEntityRequest,
    request: SubmitAppForReviewRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/submitVersion`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function setAdditionalSelectedBuilds(
    resourceIds: StepRunEntityRequest,
    request: UpdateAdditionalSelectedBuildsInAppStoreRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/additionalSelectedBuilds`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateAppStoreSettings(
    resourceIds: StepRunEntityRequest,
    request: UpdateAppStoreSettingsRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/appStoreSettings`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function rejectAppleSubmission(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/rejectVersion`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth);
}

export function releaseAppleVersion(
    resourceIds: StepRunEntityRequest,
    request: ReleaseAppleVersionRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/releaseVersion`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

// Helpers
const runwayFetchWithAuth: <T>(
    url: string,
    method: ApiRequestType,
    auth: AuthCredentials,
    baseHeaders?: Record<string, string>,
    body?: BodyInit,
    queryParams?: unknown,
    signal?: AbortSignal,
) => Promise<T> = (url, method, auth, baseHeaders = null, body = null, queryParams = null, signal = null) => {
    const fullUrl = generateUrl(url, queryParams);
    const allHeaders = withRunwayHeaders(baseHeaders);
    const headers = withAuthorizationHeaders(auth, allHeaders);

    return runwayFetch(fullUrl, method, headers, body, signal).then((json) => parseRunwayResponse(json));
};

const runwayFetchWithAuthV2: <T>(
    url: string,
    method: ApiRequestType,
    auth: AuthCredentials,
    baseHeaders?: Record<string, string>,
    body?: BodyInit,
    queryParams?: unknown,
    signal?: AbortSignal,
) => Promise<RunwayResponseV2<T>> = async <T>(url, method, auth, baseHeaders, body, queryParams, signal) => {
    const fullUrl = generateUrl(url, queryParams);
    const allHeaders = withRunwayHeaders(baseHeaders);
    const headers = withAuthorizationHeaders(auth, allHeaders);
    const json = await runwayFetch(fullUrl, method, headers, body, signal);
    return parseRunwayResponseV2<T>(json as RunwayResponseV2<T>);
};

const runwayFetchWithoutAuth: <T>(
    url: string,
    method: ApiRequestType,
    headers?: Record<string, string>,
    body?: BodyInit,
) => Promise<T> = (url, method, headers, body) => {
    const fullUrl = generateUrl(url);
    const allHeaders = withRunwayHeaders(headers);

    return runwayFetch(fullUrl, method, allHeaders, body).then((json) => parseRunwayResponse(json));
};

export enum RunwayErrorType {
    Unauthorized = 'unauthorized',
    General = 'general',
}

/* Private - Do not call directly */

const runwayFetch: <T>(
    url: string,
    method: ApiRequestType,
    headers?: HeadersInit,
    body?: BodyInit,
    signal?: AbortSignal,
) => Promise<T> = (url, method, headers, body = null, signal = null) => {
    return fetch(url, {
        headers: headers ?? {},
        method,
        body,
        signal,
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else if ([401, 403].includes(response.status)) {
            // unauthorized
            const error = new Error();
            error.name = RunwayErrorType.Unauthorized;
            error.message = 'Unauthorized. Please try again.';

            throw error;
        } else {
            // general network error
            const error = new Error();
            error.name = RunwayErrorType.General;
            error.message = 'Something went wrong, please try again.';

            throw error;
        }
    });
};

export const generateUrl: (path: string, queryParams?: unknown, baseUrl?: string) => string = (
    path,
    queryParams,
    baseUrl = window.location.origin,
) => {
    const url = `${baseUrl}/${path}`;

    if (queryParams) {
        const encodedParams = qs.stringify(queryParams);

        return `${url}?${encodedParams}`;
    }

    return `${baseUrl}/${path}`;
};

const parseRunwayResponse: <T>(response: unknown) => T = (response) => {
    const runwayResponse = response as RunwayResponse;

    if (runwayResponse && runwayResponse.data && runwayResponse.success) {
        return runwayResponse.data;
    } else if (
        runwayResponse &&
        runwayResponse.data == null &&
        runwayResponse.success &&
        !runwayResponse.errorMessage
    ) {
        return null;
    } else if (!runwayResponse.success && runwayResponse.errorMessage) {
        throw new Error(runwayResponse.errorMessage);
    } else {
        throw new Error('Something went wrong, please try again');
    }
};

//  custom error type RunwayResponseError
export class RunwayResponseError extends Error {
    public runwayResponse: RunwayResponseV2;

    constructor(runwayResponse: RunwayResponseV2) {
        super(runwayResponse.message);
        this.runwayResponse = runwayResponse;
    }
}

const parseRunwayResponseV2: <T>(runwayResponse: Nullable<RunwayResponseV2<T>>) => Nullable<RunwayResponseV2<T>> = (
    runwayResponse,
) => {
    if (!runwayResponse || !runwayResponse.type) {
        throw new Error('Something went wrong, please try again.');
    }

    switch (runwayResponse.type) {
        case RunwayResponseType.Info:
        case RunwayResponseType.Success:
        case RunwayResponseType.Warning:
            return runwayResponse;
        case RunwayResponseType.Error:
            throw new RunwayResponseError(runwayResponse);
    }
};

export const withAuthorizationHeaders: (
    auth: AuthCredentials,
    additionalHeaders?: Record<string, string>,
) => Record<string, string> = (auth: AuthCredentials, additionalHeaders: Record<string, string> = {}) => {
    return merge(additionalHeaders, { Authorization: `Bearer ${auth.token}` });
};

const withRunwayHeaders = (headers: Record<string, string> = {}) => {
    const updatedHeaders = {
        ...headers,
    };

    const sessionId = AnalyticEvents.getAmplitudeSessionId();
    const deviceId = AnalyticEvents.getAmplitudeDeviceId();

    if (sessionId) {
        updatedHeaders['X-RUNWAY-SESSION-ID'] = sessionId.toString();
    }

    if (deviceId) {
        updatedHeaders['X-RUNWAY-DEVICE-ID'] = deviceId;
    }

    return updatedHeaders;
};

export function listPendingWorkOwnersComms(
    request: PingAllPendingWorkOwnersRequest,
    auth: AuthCredentials,
): Promise<CommsMention[]> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const params = new URLSearchParams();
    if (request.shouldPingAllWorkOwners) {
        params.append('shouldPingAllWorkOwners', 'true');
    }
    if (request.itemsToPingOwnersOf && request.itemsToPingOwnersOf.length > 0) {
        params.append('itemsToPingOwnersOf', request.itemsToPingOwnersOf.join(','));
    }
    const url = `${releaseUrl}/listPendingWorkOwnersComms?${params.toString()}`;
    return runwayFetchWithAuth(url, ApiRequestType.get, auth, jsonBaseHeaders);
}

export function pingAllPendingWorkOwners(
    request: PingAllPendingWorkOwnersRequest,
    auth: AuthCredentials,
): Promise<unknown> {
    const releaseUrl = releaseEndpoint(request.orgId, request.appId, request.releaseId);
    const url = `${releaseUrl}/pingAllPendingWorkOwners`;
    const body = {
        shouldPingAllWorkOwners: request.shouldPingAllWorkOwners,
        itemsToPingOwnersOf: request.itemsToPingOwnersOf,
    };
    return runwayFetchWithAuth(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function sendNotificationTestDM(
    request: SendNotificationTestDMRequest,
    auth: AuthCredentials,
): Promise<unknown> {
    const appUrl = appEndpoint(request.orgId, request.appId);
    const url = `${appUrl}/sendNotificationTestDM/${request.notificationId}`;
    return runwayFetchWithAuth(url, ApiRequestType.post, auth);
}

export function getReleaseCalendar(
    request: GetReleaseCalendarRequest,
    auth: AuthCredentials,
): Promise<AllReleaseCalendarData> {
    const appUrl = appEndpoint(request.orgId, request.appId);

    const queryParams = {};
    if (request.releaseId) {
        queryParams['releaseId'] = request.releaseId;
    }
    const encodedQueryParams = qs.stringify(queryParams);

    const url = `${appUrl}/releaseCalendar?${encodedQueryParams}`;
    return runwayFetchWithAuth(url, ApiRequestType.get, auth);
}

export function getOrgSummaryView(
    request: OrgSummaryViewEntityRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<SummaryViewResponseAPI>> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/summaryView`;
    const body = {
        versions: request.versions,
        appToDestinationIds: request.appToDestinationIds,
        properties: request.properties,
        offset: request.offset,
        limit: request.limit,
    };

    return runwayFetchWithAuthV2<SummaryViewResponseAPI>(
        url,
        ApiRequestType.post,
        auth,
        jsonBaseHeaders,
        JSON.stringify(body),
        null,
    );
}

export function getOrgDestinationsAndVersions(
    request: { orgId: string },
    auth: AuthCredentials,
): Promise<RunwayResponseV2<OrgDestinationsResponse>> {
    const { orgId } = request;
    const orgUrl = orgEndpoint(orgId);
    const url = `${orgUrl}/destinationsAndVersions`;

    return runwayFetchWithAuthV2(url, ApiRequestType.get, auth, jsonBaseHeaders);
}

export function tagRelease(
    resourceIds: StepRunEntityRequest,
    request: TagReleaseRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/tag`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function markAndroidSubmissionRejected(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/markRejected`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updatePhasedRelease(
    resourceIds: StepRunEntityRequest,
    request: UpdatePhasedReleaseRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/phasedRelease`;
    const body = {
        phaseState: request.phaseState,
        resumeAutomations: request.resumeAutomations,
        actionType: request.actionType,
        userFraction: request.userFraction,
    };

    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function startAutomatedAndroidStagedRollout(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/startAutomatedStagedRollout`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateMetadata(
    resourceIds: StepRunEntityRequest,
    request: UpdateMetadataRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    let url = `${stepRunEndpoint(resourceIds)}/updateMetadata`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function approveMetadata(
    resourceIds: StepRunEntityRequest,
    request: ApproveMetadataRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    let url = `${stepRunEndpoint(resourceIds)}/approveMetadata`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function overrideCiFailure(
    resourceIds: StepRunEntityRequest,
    request: OverrideCIFailureRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/overrideCiFailure`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteScreenshot(
    resourceIds: StepRunEntityRequest,
    request: DeleteScreenshotRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/screenshots/delete`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateScreenshotsApproval(
    resourceIds: StepRunEntityRequest,
    request: UpdateScreenshotsApprovalRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/screenshots/approval`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateApprovalOverride(
    resourceIds: StepRunEntityRequest,
    request: UpdateApprovalOverrideRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/approvalOverride`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function addReviewSubmissionItem(
    resourceIds: StepRunEntityRequest,
    request: AddReviewSubmissionItemRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/reviewSubmissionItem`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function removeReviewSubmissionItem(
    resourceIds: StepRunEntityRequest,
    request: RemoveReviewSubmissionItemRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/reviewSubmissionItem/${request.itemId}`;
    return runwayFetchWithAuthV2(url, ApiRequestType.delete, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function unblockReviewSubmission(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/unblockReviewSubmission`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function cancelReviewSubmission(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/cancelSubmission`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function triggerBuildSystemWorkflow(
    resourceIds: StepRunEntityRequest,
    request: TriggerBuildSystemWorkflowRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/buildSystem/trigger`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function retryArtifactUpload(
    resourceIds: StepRunEntityRequest,
    request: RetryArtifactUploadRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/retryAppStoreUpload`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function lockBuild(
    resourceIds: StepRunEntityRequest,
    request: LockBuildRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/lockBuild`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function unlockBuild(
    resourceIds: StepRunEntityRequest,
    request: void,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const url = `${stepRunEndpoint(resourceIds)}/unlockBuild`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function updateRegressionTestingStatus(
    resourceIds: StepRunEntityRequest,
    request: UpdateRegressionStatusRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    let url = `${stepRunEndpoint(resourceIds)}/updateRegressionStatus`;
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function getChecklistItemOrgTemplates(
    request: BaseUpdateOrgSettingsRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<ChecklistItemTemplate[]>> {
    const orgUrl = orgEndpoint(request.orgId);
    const url = `${orgUrl}/checklistItemOrgTemplate`;
    return runwayFetchWithAuthV2(url, ApiRequestType.get, auth);
}

export function createChecklistItemOrgTemplate(
    resourceIds: OrgEntityRequest,
    request: CreateOrgChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const { orgId, ...rest } = request;
    const orgUrl = orgEndpoint(orgId);
    const url = `${orgUrl}/checklistItemOrgTemplate`;
    const body = {
        ...rest,
    };
    return runwayFetchWithAuthV2(url, ApiRequestType.post, auth, jsonBaseHeaders, JSON.stringify(body));
}

export function updateChecklistItemOrgTemplate(
    resourceIds: OrgEntityRequest,
    request: UpdateOrgChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const orgUrl = orgEndpoint(resourceIds.orgId);
    const url = `${orgUrl}/checklistItemOrgTemplate/${request.checklistItemId}`;
    return runwayFetchWithAuthV2(url, ApiRequestType.put, auth, jsonBaseHeaders, JSON.stringify(request));
}

export function deleteChecklistItemOrgTemplate(
    resourceIds: OrgEntityRequest,
    request: DeleteOrgChecklistItemTemplateRequest,
    auth: AuthCredentials,
): UpdatableEndpointResponse {
    const orgUrl = orgEndpoint(resourceIds.orgId);
    const url = `${orgUrl}/checklistItemOrgTemplate/${request.checklistItemId}`;
    return runwayFetchWithAuthV2(url, ApiRequestType.delete, auth, jsonBaseHeaders);
}

export function pingPendingChecklistItemsForStepGroup(
    resourceIds: WorkflowRunEntityRequest,
    request: PingPendingChecklistItemsForStepGroupRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<RunwayModelsResponse>> {
    const workflowRunUrl = workflowRunEndpoint(resourceIds);
    const url = `${workflowRunUrl}/pingAllPending`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        url,
        ApiRequestType.post,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}

export function bulkMarkCLIsAsCompleted(
    resourceIds: WorkflowRunEntityRequest,
    request: BulkMarkCLIsAsCompletedRequest,
    auth: AuthCredentials,
): Promise<RunwayResponseV2<RunwayModelsResponse>> {
    const workflowRunUrl = workflowRunEndpoint(resourceIds);
    const url = `${workflowRunUrl}/markCLIsAsCompleted`;
    return runwayFetchWithAuthV2<RunwayModelsResponse>(
        url,
        ApiRequestType.post,
        auth,
        jsonBaseHeaders,
        JSON.stringify(request),
    );
}
